import { RegistrationForm } from "./Registration";

export default RegistrationForm;